export default __webpack_public_path__ + "static/media/5197052.fbf91d38.jpg";